var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M16.4475 21.8892C16.4475 21.5974 16.5637 21.3057 16.7955 21.0833L24.0954 14.0839C24.5598 13.6387 25.3127 13.6387 25.7769 14.0839C26.241 14.529 26.241 15.2508 25.7769 15.6961L19.3175 21.8892L25.7766 28.0823C26.2408 28.5276 26.2408 29.2493 25.7766 29.6943C25.3125 30.1398 24.5596 30.1398 24.0952 29.6943L16.7953 22.695C16.5634 22.4725 16.4475 22.1808 16.4475 21.8892V21.8892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24583",
    opacity: 0.4,
    x: -0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 43 0)",
    stroke: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackward);
export default __webpack_public_path__ + "static/media/iconBackward.46626c0ca8fa1a4913fc472dc3600673.svg";
export { ForwardRef as ReactComponent };